import type { FunctionComponent } from "react";

import { SingleSelect } from "@alpacahq/ui/old";

import type { DocumentRequestResponse } from "~/v2/api/rest/account";
import {
  FILE_ACCEPTED_TYPES,
  FILE_MAX_SIZE,
  FILE_SIZE_LABEL,
  FileDropzone,
} from "~/v2/components/fileUpload";
import type { useRequestedDocumentUpload } from "./RequestedDocumentUpload.controller";

export const SUPPORTED_MIME_TYPES = FILE_ACCEPTED_TYPES;

interface RequestedDocumentUploadPresProps
  extends ReturnType<typeof useRequestedDocumentUpload> {
  documentRequest?: DocumentRequestResponse;
}

export const RequestedDocumentUploadPres: FunctionComponent<
  RequestedDocumentUploadPresProps
> = ({
  content,
  documentRequest,
  onSelectedDocTypeChange,
  onUpload,
  onError,
  onRemove,
  file,
  validatedValue,
  isLoading,
}) => {
  if (!content) {
    return null;
  }

  const { title, description, selectOptions } = content;

  return (
    <div className="w-full max-w-xl rounded-lg border border-gray-200 bg-white p-6">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <label
            htmlFor={documentRequest?.doc_type ?? ""}
            className="block font-medium text-sm"
          >
            {title}
          </label>
        </div>

        <div className="text-gray-600 text-sm">
          <div className="flex flex-col gap-4">
            <div>{description}</div>
            {selectOptions && selectOptions.length > 0 && (
              <div>
                <label className="mb-2 block font-medium text-gray-700 text-sm">
                  Document type
                </label>
                <SingleSelect
                  options={selectOptions}
                  value={validatedValue}
                  onChange={onSelectedDocTypeChange}
                  placeholder="Select document type"
                />
              </div>
            )}
          </div>
        </div>

        <FileDropzone
          name={documentRequest?.doc_type ?? ""}
          label={title}
          file={file}
          placeholder={documentRequest?.doc_type ?? ""}
          onUpload={onUpload}
          onError={onError}
          onRemove={onRemove}
          isRequired
          maxSize={FILE_MAX_SIZE}
          maxSizeLabel={FILE_SIZE_LABEL}
          accept={SUPPORTED_MIME_TYPES.join(",")}
          displayType="file"
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};
